/* eslint-disable no-undefined */
/* eslint-disable react/jsx-quotes */
/* eslint-disable react/jsx-sort-prop-types */

import { getDomain } from "./domain.js";
import getV2AxiosInstance from "./v2Axios.js";
import { setAudioSettings } from "../actions/common.js";

const landingUrl = `${getDomain(true)}/landing/#/no-phone`;

const default_settings = {
  language: "es",
  theme: "default",
  layout: {
    panels_display: {
      telephony: true,
      calls_in_queue: true,
      incoming_calls: true,
      outgoing_calls: true,
      autodialer: true,
      chat: false,
      agent: true,
      web_phone: false,
    },
    panels_order: {
      telephony: 2,
      calls_in_queue: 3,
      incoming_calls: 4,
      outgoing_calls: 5,
      autodialer: 8,
      chat: 6,
      agent: 7,
      web_phone: 1,
    },
  },
};

// ojo revisar
export const customGetAgentCred = () => {
  return new Promise((resolve, reject) => {
    // const url = "/bridge/en/invoxapi/Agent";
    const url = "/api/es/invoxapi/agent/self";
    const action = "getExtensionByUser";
    const username = localStorage.getItem("username");
    //console.log(username)
    getV2AxiosInstance()
      .get(url, { action: action })
      .then(({ data }) => {
        if (
          data.result &&
          data.response &&
          data.response.items &&
          data.response.items.length
          //  && data.response.items[0].data.extension &&
          // data.response.items[0].data.id
        ) {
          //console.log(data)
          resolve({
            agent_status: true,
            agent_data: {
              agent_id: data.response.items[0].data.id,
              username: data.response.items[0].data.username,
              extension: data.response.items[0].data.extension,
              email: data.response.items[0].data.email,
            },
          });
        } else {
          //console.log("landingUrl invalid data");
          window.location = landingUrl;
        }
      })
      .catch(() => {
        window.location = landingUrl;
      });
  });
};

export const customGetConnectionToken = (agent_id) => {
  return new Promise((resolve, reject) => {
    getV2AxiosInstance()
      .get(`/api/es/invoxapi/agent/${agent_id}`)
      .then(({ data }) => {
        if (
          data.result &&
          data.response &&
          data.response.items &&
          data.response.items.length &&
          data.response.items[0].id &&
          data.response.items[0].data &&
          data.response.items[0].data.extra_data &&
          data.response.items[0].data.extra_data.connection_token
        ) {
          resolve({
            ext_status: true,
            connection_token:
              data.response.items[0].data.extra_data.connection_token,
            hasListenCall:
              data.response.items[0].data.supervisor_runtime_listen,
            hasHangup: data.response.items[0].data.supervisor_runtime_hangout,
            hasRecordingCall: data.response.items[0].data.allow_call_recording,
            license: data.response.items[0].data.license,
            clientId: data.response.items[0].data.client_id,
          });
        } else {
          window.location = landingUrl;
        }
      })
      .catch(() => {
        window.location = landingUrl;
      });
  });
};

const getThemeFromEntity = (theme) => {
  if (theme === "light") {
    return "default";
  } else if (theme) {
    return theme;
  } else {
    return "default";
  }
};

export const customGetUserProperties = (config) => {
  return new Promise((resolve, reject) => {
    const username = localStorage.getItem("username");

    getV2AxiosInstance()
      .get(`/api/es/invoxapi/userproperties/${username}`)
      .then(({ data }) => {
        if (
          data.result &&
          data.response &&
          data.response.items &&
          data.response.items.length &&
          data.response.items[0].id &&
          data.response.items[0].data &&
          data.response.items[0].data.apps &&
          data.response.items[0].data.apps.webagent
        ) {
          const webagent = data.response.items[0].data.apps.webagent;
          const layout = webagent.layout ? webagent.layout : {};
          const panels_order = layout.panels_order ? layout.panels_order : {};
          const panels_display = layout.panels_display
          ? layout.panels_display
          : {};
          const config_webagent = config.configuration;
          
          let audioSettings;

          if (
            data.response.items[0].data &&
            data.response.items[0].data.apps &&
            data.response.items[0].data.apps.webphone &&
            data.response.items[0].data.apps.webphone.audio_settings
          ) {
             audioSettings =
              data.response.items[0].data.apps.webphone.audio_settings;
          } else {
             audioSettings = {
              output_ring_device: "",
              output_voice_device: "",
            };
          }

          resolve({
            prop_status: true,
            properties: {
              language: config.language ? config.language : "es",
              theme: getThemeFromEntity(webagent.theme),
              audioSettings: audioSettings,
              layout: {
                panels_display: {
                  telephony:
                    panels_display.telephony !== undefined &&
                    panels_display.telephony !== null
                      ? panels_display.telephony
                      : config_webagent.panels_display.telephony,
                  calls_in_queue:
                    panels_display.calls_in_queue !== undefined &&
                    panels_display.calls_in_queue !== null
                      ? panels_display.calls_in_queue
                      : config_webagent.panels_display.calls_in_queue,
                  incoming_calls:
                    panels_display.incoming_calls !== undefined &&
                    panels_display.incoming_calls !== null
                      ? panels_display.incoming_calls
                      : config_webagent.panels_display.incoming_calls,
                  outgoing_calls:
                    panels_display.outgoing_calls !== undefined &&
                    panels_display.outgoing_calls !== null
                      ? panels_display.outgoing_calls
                      : config_webagent.panels_display.outgoing_calls,
                  autodialer:
                    panels_display.autodialer !== undefined &&
                    panels_display.autodialer !== null
                      ? panels_display.autodialer
                      : config_webagent.panels_display.autodialer,
                  chat: false,
                  agent:
                    panels_display.agent !== undefined &&
                    panels_display.agent !== null
                      ? panels_display.agent
                      : config_webagent.panels_display.agent,
                  web_phone:
                    panels_display.web_phone !== undefined &&
                    panels_display.web_phone !== null
                      ? panels_display.web_phone
                      : config_webagent.panels_display.web_phone,
                },

                panels_order: {
                  telephony: panels_order.telephony
                    ? panels_order.telephony
                    : config_webagent.panels_order.telephony,
                  calls_in_queue: panels_order.calls_in_queue
                    ? panels_order.calls_in_queue
                    : config_webagent.panels_order.calls_in_queue,
                  incoming_calls: panels_order.incoming_calls
                    ? panels_order.incoming_calls
                    : config_webagent.panels_order.incoming_calls,
                  outgoing_calls: panels_order.outgoing_calls
                    ? panels_order.outgoing_calls
                    : config_webagent.panels_order.outgoing_calls,
                  autodialer: panels_order.autodialer
                    ? panels_order.autodialer
                    : config_webagent.panels_order.autodialer,
                  chat: panels_order.chat
                    ? panels_order.chat
                    : config_webagent.panels_order.chat,
                  agent: panels_order.agent
                    ? panels_order.agent
                    : config_webagent.panels_order.agent,
                  web_phone: panels_order.web_phone
                    ? panels_order.web_phone
                    : config_webagent.panels_order.web_phone,
                },
              },
            },
          });
        } else {
          const config_webagent = config.configuration;
          const language = config.language;
          let audioSettings =
            data.response.items[0].apps.webphone.audio_settings;

          resolve({
            prop_status: false,
            properties: {
              language: language ? language : "es",
              theme: getThemeFromEntity(config_webagent.preference.themetype),
              audioSettings: audioSettings,
              layout: {
                panels_display: {
                  telephony: config_webagent.panels_display.telephony,
                  // ? config_webagent.panels_display.telephony
                  // : true,
                  calls_in_queue: config_webagent.panels_display.calls_in_queue,
                  // ? config_webagent.panels_display.calls_in_queue
                  // : true,
                  incoming_calls: config_webagent.panels_display.incoming_calls,
                  // ? config_webagent.panels_display.incoming_calls
                  // : true,
                  outgoing_calls: config_webagent.panels_display.outgoing_calls,
                  // ? config_webagent.panels_display.outgoing_calls
                  // : true,
                  autodialer: config_webagent.panels_display.autodialer,
                  // ? config_webagent.panels_display.autodialer
                  // : true,
                  chat: false,
                  agent: config_webagent.panels_display.agent,
                  //  ? config_webagent.panels_display.agent
                  //  : true,
                  web_phone:
                    config_webagent.panels_display.web_phone !== undefined
                      ? config_webagent.panels_display.web_phone
                      : false,
                },
                panels_order: {
                  telephony: config_webagent.panels_order.telephony
                    ? config_webagent.panels_order.telephony
                    : 2,
                  calls_in_queue: config_webagent.panels_order.calls_in_queue
                    ? config_webagent.panels_order.calls_in_queue
                    : 3,
                  incoming_calls: config_webagent.panels_order.incoming_calls
                    ? config_webagent.panels_order.incoming_calls
                    : 4,
                  outgoing_calls: config_webagent.panels_order.outgoing_calls
                    ? config_webagent.panels_order.outgoing_calls
                    : 5,
                  autodialer: config_webagent.panels_order.autodialer
                    ? config_webagent.panels_order.autodialer
                    : 8,
                  chat: config_webagent.panels_order.chat
                    ? config_webagent.panels_order.chat
                    : 6,
                  agent: config_webagent.panels_order.agent
                    ? config_webagent.panels_order.agent
                    : 7,
                  web_phone: config_webagent.panels_order.web_phone
                    ? config_webagent.panels_order.web_phone
                    : 1,
                },
              },
            },
          });
        }
      })
      .catch((error) => {
        const config_webagent = config.configuration;
        const language = config.language;

        reject({
          prop_status: false,
          properties: {
            language: language ? language : "es",
            theme: getThemeFromEntity(config_webagent.preference.themetype),
            layout: {
              panels_display: {
                telephony: config_webagent.panels_display.telephony,
                // ? config_webagent.panels_display.telephony
                // : true,
                calls_in_queue: config_webagent.panels_display.calls_in_queue,
                // ? config_webagent.panels_display.calls_in_queue
                // : true,
                incoming_calls: config_webagent.panels_display.incoming_calls,
                // ? config_webagent.panels_display.incoming_calls
                // : true,
                outgoing_calls: config_webagent.panels_display.outgoing_calls,
                // ? config_webagent.panels_display.outgoing_calls
                // : true,
                autodialer: config_webagent.panels_display.autodialer,
                // ? config_webagent.panels_display.autodialer
                // : true,
                chat: false,
                agent: config_webagent.panels_display.agent,
                //  ? config_webagent.panels_display.agent
                //  : true,
                web_phone:
                  config_webagent.panels_display.web_phone !== undefined
                    ? config_webagent.panels_display.web_phone
                    : false,
              },
              panels_order: {
                telephony: config_webagent.panels_order.telephony
                  ? config_webagent.panels_order.telephony
                  : 2,
                calls_in_queue: config_webagent.panels_order.calls_in_queue
                  ? config_webagent.panels_order.calls_in_queue
                  : 3,
                incoming_calls: config_webagent.panels_order.incoming_calls
                  ? config_webagent.panels_order.incoming_calls
                  : 4,
                outgoing_calls: config_webagent.panels_order.outgoing_calls
                  ? config_webagent.panels_order.outgoing_calls
                  : 5,
                autodialer: config_webagent.panels_order.autodialer
                  ? config_webagent.panels_order.autodialer
                  : 8,
                chat: config_webagent.panels_order.chat
                  ? config_webagent.panels_order.chat
                  : 6,
                agent: config_webagent.panels_order.agent
                  ? config_webagent.panels_order.agent
                  : 7,
                web_phone: config_webagent.panels_order.web_phone
                  ? config_webagent.panels_order.web_phone
                  : 1,
              },
            },
          },
          prop_error: error,
        });
      });
  });
};



// WEBPACK FOOTER //
// ./src/utils/apihelpers.js